"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { api, ApiError, User } from "@/lib/api";

const UserContext = createContext<User | null>(null);

export function useUser(): User {
  const user = useContext(UserContext);
  if (!user) throw new Error("AuthGuard 내부에서만 사용할 수 있습니다");
  return user;
}

/** 세션 확인 후 자식 렌더. 미로그인이면 /login으로 보낸다 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    api<User>("/api/auth/me")
      .then(setUser)
      .catch((e) => {
        if (e instanceof ApiError && e.status === 401) router.replace("/login");
      })
      .finally(() => setLoading(false));
  }, [router]);

  if (loading) {
    return <div className="p-8 text-slate-500">세션 확인 중…</div>;
  }
  if (!user) return null;
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
